<div class="attendance-shell" [attr.inert]="finalizeOpen||(reasonOpen&&pendingLifecycle==='correct')?'':null">
  <aside class="side-menu">
    @if (!isOperationEntry) {
      <button class="side-link" (click)="openDocument('plan')">企画書</button>
    }
    <div class="side-link active">出欠・参加管理</div>
    @if (!isOperationEntry && canOpenReport && (dashboard?.hasReport || setup?.hasReport)) {
      <button class="side-link" (click)="openDocument('report')">報告書</button>
    }
    <button class="back-button" mat-raised-button (click)="back()">企画書へ戻る</button>
  </aside>

  <main class="main-area">
    @if ((setup || dashboard) && releaseReadOnly) {
      <p class="schedule-notice" role="status">{{ releaseMessage }}</p>
    }
    @if (showSpinner && !dashboard && !setup) {
      <div class="spinner"><mat-spinner diameter="56"></mat-spinner></div>
    } @else if (errorMessage && !dashboard && !setup) {
      <div class="error-box">{{ errorMessage }}</div>
      <button mat-raised-button (click)="back()">企画書へ戻る</button>
    } @else if (setup) {
      <header class="page-header"><div><p class="eyebrow">{{ setup.title }}</p><h1>出欠設定</h1></div>@if (setupOpened) { <button mat-stroked-button (click)="cancelSettings()">変更せず戻る</button> }</header>
      @if (errorMessage) { <p class="error-box" role="alert">{{ errorMessage }} <button (click)="load()">再読み込み</button></p> }
      <app-attendance-setup-form [setup]="setup" [showSpinner]="showSpinner || releaseReadOnly" [setupOpened]="setupOpened" [setupChanged]="setupChanged"
        [(answerDate)]="answerDate" [(answerTime)]="answerTime" (changed)="setupReady=false" (save)="saveSetup()"></app-attendance-setup-form>
      @if (setupReady && !setupOpened) {
        <section class="card">
          <div class="card-heading"><div><h2>開始前の対象者確認（{{ setup.targets.length }}人）</h2></div></div>
          <div class="draft-toolbar toolbar"><span>{{ draftSelected.size }}人を選択中</span><button mat-stroked-button class="danger" [disabled]="releaseReadOnly || showSpinner || !draftSelected.size" (click)="excludeDraft()">選択した人を除外</button><button mat-raised-button class="primary" [disabled]="releaseReadOnly || showSpinner" (click)="openAddDialog()">対象者を追加</button></div>
          <ng-container *ngTemplateOutlet="additionPanel"></ng-container>
          <app-attendance-draft-table [targets]="setup.targets" [selected]="draftSelected" [disabled]="releaseReadOnly || showSpinner"
            (selection)="toggleDraft($event.id,$event.checked)" (all)="selectAllDraft($event)"></app-attendance-draft-table>
          @if (!setup.targets.length) { <p class="empty-roster">対象者がいません。「対象者を追加」から1人以上追加してください。</p> }
          <div class="setup-actions"><button mat-raised-button class="primary" [disabled]="releaseReadOnly || showSpinner || !setup.targets.length || invalidDraftTargets || !!addCandidates.length" (click)="startReception()">この対象者で回答受付を開始</button></div>
        </section>
      }
    } @else if (dashboard) {
      <header class="page-header">
        <div>
          <p class="eyebrow">{{ dashboard.title }}</p>
          <h1>出欠・参加管理</h1>
        </div>
        <span class="status">{{ statusLabel }}</span>
        <button mat-stroked-button [disabled]="releaseReadOnly || showSpinner || dashboard.status === 'finalized'" (click)="editSettings()">設定を変更</button>
      </header>

      @if (errorMessage) {
        <div class="error-box">{{ errorMessage }} <button type="button" (click)="load()">再読み込み</button></div>
      }
      @if (dashboard.status === 'cancelled' || dashboard.status === 'postponed') {
        <section class="card operation-notice"><h2>{{ statusLabel }}のため受付を停止しています</h2><p>登録済みの回答・実績は保持しています。再開する場合は日程と回答期限を確認してください。</p>
          @if (dashboard.operation.reportStop) { <p>既存報告書も中止・延期になっています。報告書を確認してから再開してください。</p> }
          <button mat-stroked-button [disabled]="releaseReadOnly || showSpinner || !!dashboard.operation.reportStop" (click)="requestLifecycle('resume')">受付を再開</button>
        </section>
      } @else if (dashboard.status === 'correcting') {
        <p class="schedule-notice">実績を修正中です。再確定するまで前回の確定版を保持し、報告書の保存・承認を停止します。</p>
      } @else if (dashboard.status !== 'finalized') {
        <div class="toolbar lifecycle-actions"><button mat-stroked-button [disabled]="editingLocked" (click)="requestLifecycle('postpone')">延期する</button><button mat-stroked-button [disabled]="editingLocked" (click)="requestLifecycle('cancel')">中止する</button></div>
      }

      <app-attendance-share [eventId]="eventId"></app-attendance-share>

      <app-attendance-summary [dashboard]="dashboard" [showSpinner]="showSpinner" [reasonOpen]="reasonOpen" [finalizeOpen]="finalizeOpen"
        [editingLocked]="editingLocked" [adding]="addCandidates.length > 0" [refreshInProgress]="refreshInProgress" [finalizationBusy]="finalizationBusy"
        [refreshIntervalSeconds]="refreshIntervalSeconds" (dateChange)="changeAttendanceDate($event)" (refresh)="load()"></app-attendance-summary>

      <section class="card">
        <div class="card-heading">
          <div>
            <h2>対象者と当日実績 @if (dashboard.attendanceDate) { <small>{{ dayLabel(dashboard.attendanceDate) }}</small> }</h2>
            <p>名簿は受付開始時点で固定されます。追加・除外・実績変更は履歴に残ります。</p>
          </div>
          <div class="toolbar">
            <button mat-raised-button class="secondary" [disabled]="editingLocked" (click)="openAddDialog()">対象者を追加</button>
            <button mat-raised-button class="danger" [disabled]="editingLocked || selected.size === 0" (click)="excludeSelected()">
              選択した{{ selected.size || '' }}人を除外
            </button>
          </div>
        </div>

        <ng-container *ngTemplateOutlet="additionPanel"></ng-container>

        <div class="list-filter" aria-label="対象者一覧の絞り込み">
          <label>
            <span>検索</span>
            <input type="search" [(ngModel)]="searchText" placeholder="氏名・所属・役職で検索">
          </label>
          <label>
            <span>状態</span>
            <select [(ngModel)]="statusFilter">
              <option value="all">すべて</option>
              <option value="not_checked_in">未登録</option>
              <option value="attended">出席</option>
              <option value="absent">欠席</option>
            </select>
          </label>
          <label>
            <span>絞り込み（{{ hierarchyFilterLabel }}）</span>
            <select [(ngModel)]="organizationFilter">
              <option value="all">全体</option>
              @for (organization of dashboard.organizationSummary; track organization.organizationId) {
                <option [value]="organization.organizationId">{{ organization.organizationPath }}</option>
              }
            </select>
          </label>
          <label>
            <span>並べ替え</span>
            <select [(ngModel)]="sortOrder">
              <option value="organization-asc">所属 昇順</option>
              <option value="organization-desc">所属 降順</option>
              <option value="name-asc">氏名 昇順</option>
              <option value="name-desc">氏名 降順</option>
              <option value="status-asc">状態 昇順</option>
              <option value="status-desc">状態 降順</option>
            </select>
          </label>
        </div>
        <p class="filter-description">企画書の対象組織の一階層下で絞り込みます。全体は、このイベントの対象者全員です。</p>
        <p class="filter-count">表示 {{ displayedTargets.length }}人 ／ 全体 {{ dashboard.targets.length }}人</p>

        <app-attendance-target-table [targets]="displayedTargets" [selected]="selected" [editingLocked]="editingLocked" [canUpdateActual]="dashboard.canUpdateActual"
          (selection)="toggle($event.id,$event.checked)" (actual)="requestActual($event.target,$event.next,$event.select)"></app-attendance-target-table>
      </section>

      <section class="card finalization-card">
        <h2>参加実績</h2><p><span class="result-state" [class.finalized]="dashboard.status==='finalized'" [class.correcting]="dashboard.status==='correcting'">{{dashboard.status==='finalized'?'確定済み':dashboard.status==='correcting'?'修正中':'未確定'}}</span></p><button mat-stroked-button [disabled]="exportBusy||showSpinner" (click)="exportAll()">出欠全データをExcel出力</button>
        @if (dashboard.attendanceMode === 'daily' && dashboard.attendanceDates.length > 1) {
          <p>全開催日を通した実出席は <strong>{{ dashboard.uniqueAttended }}人</strong>です。複数日に出席した人も1人として報告書へ反映します。</p>
        }
        @if (dashboard.status === 'correcting') {
          <p>変更後に実績を再確定してください。</p>
        } @else if (finalization) {
          <p>実出席 <strong>{{ finalization.attended }}人</strong> ／ 対象者 {{ finalization.total }}人で確定済みです。</p>
          <p role="status">{{ transferMessage }}</p>
          @if (finalization.syncState !== 'applied' || (finalization.reportSync && !['applied','awaiting_finalization'].includes(finalization.reportSync.state))) {
            <button mat-raised-button [disabled]="releaseReadOnly || finalizationBusy" (click)="retryTransfer()">転記を再確認する</button>
          }

        } @else if (dashboard.status === 'finalized') {
          <p>参加実績は確定済みです。報告書への反映状況を取得しています。</p>
          @if (finalizationError) {
            <button mat-raised-button [disabled]="showSpinner" (click)="load()">確定情報を再取得</button>
          }
        } @else {
          <p>開催後に参加実績を確定してください。報告書は後から作成でき、確定人数が自動反映されます。</p>
        }
        @if (finalizationError) { <p class="error-box" role="alert">{{ finalizationError }}</p> }
      </section>

      @if (showSpinner) { <div class="saving"><mat-spinner diameter="38"></mat-spinner></div> }
    }
    @if (dashboard?.history || setup?.history) {
      <app-attendance-history [items]="dashboard?.history || setup?.history || []" [additionRoles]="additionRoles"></app-attendance-history>
    }
    @if(dashboard&&!setup){<div class="result-footer">
      @if(dashboard.status==='finalized'){
        @if(correctionBlockedReason){<p>{{correctionBlockedReason}}</p>}
        <button mat-stroked-button [disabled]="showSpinner||finalizationBusy||!!correctionBlockedReason" (click)="requestLifecycle('correct')">参加実績を修正する</button>
      }@else{
        @if(addCandidates.length){<p>対象者の追加を完了してから確定してください。</p>}
        @if(dashboard.status==='cancelled'||dashboard.status==='postponed'||dashboard.operation.reportStop){<p>中止・延期中は確定できません。</p>}
        <button mat-raised-button class="primary" [disabled]="editingLocked||addCandidates.length>0" (click)="prepareFinalization()">{{dashboard.status==='correcting'?'参加実績を再確定する':'参加実績を確定する'}}</button>
      }
    </div>}
  </main>
</div>

@if (finalizeOpen && finalPreview) {
  <app-result-action-dialog [title]="dashboard?.status==='correcting'?'参加実績を再確定する':'参加実績を確定する'" [confirmLabel]="dashboard?.status==='correcting'?'再確定する':'確定する'" [busy]="finalizationBusy" [disabled]="releaseReadOnly" [error]="finalizationError" (cancelled)="finalizeOpen=false" (confirmed)="confirmFinalization()">
      <p>対象者 {{ finalPreview.total }}人 ／ 実出席 {{ finalPreview.attended }}人（全開催日の実人数）</p>
      @if (finalPreview.dailySummary.length > 1) {
        <div class="daily-final-summary">
          @for (day of finalPreview.dailySummary; track day.date) {
            <div><strong>{{ dayLabel(day.date) }}</strong><p>出席 {{ day.attended }}人 ／ 欠席 {{ day.absent }}人 ／ 未登録 {{ day.notCheckedIn }}人</p>
              @if (day.quorum) { <p>会議成立：{{ day.quorum.met ? '成立' : '未成立' }}（{{ day.quorum.attended }}/{{ day.quorum.required }}人）</p> }
            </div>
          }
        </div>
      } @else { <p>欠席 {{ finalPreview.absent }}人 ／ 未登録 {{ finalPreview.notCheckedIn }}人。未登録は実出席に含めません。</p> }
      @if (finalPreview.quorumStatus !== 'none' && finalPreview.quorumStatus !== 'daily') {
        <p>会議成立：{{ finalPreview.quorumStatus === 'met' ? '成立' : '未成立' }}（{{ finalPreview.quorumAttended }}/{{ finalPreview.quorumRequired }}人）</p>
      }
    <p>全開催日の実績を確定し、報告書に連携します。報告書は後から作成できます。</p>
  </app-result-action-dialog>
}
@if(reasonOpen&&pendingLifecycle==='correct'){
  <app-result-action-dialog title="参加実績を修正する" confirmLabel="修正を開始する" [requiresReason]="true" [(reason)]="reason" [busy]="showSpinner" [disabled]="releaseReadOnly" [error]="errorMessage" (cancelled)="cancelReason()" (confirmed)="saveLifecycle()">
    <p>再確定まで前回の確定版を保持し、報告書の保存・承認を停止します。</p>
  </app-result-action-dialog>
}

@if (reasonOpen && pendingLifecycle !== 'correct') {
  <div class="modal-backdrop" (click)="cancelReason()">
    <section class="reason-dialog" role="dialog" aria-modal="true" aria-labelledby="reason-title" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (click)="$event.stopPropagation()">
      <h2 id="reason-title">{{ reasonTitle }}</h2>
      @if (pendingLifecycle !== 'resume') { <p>{{ dialogReasonLabel }}は変更履歴に保存されます。</p> }
      @if (pendingLifecycle === 'resume') { <p>これから開催する日の事前回答を未回答に戻します。日程変更後の出欠を参加者に再確認してください。</p> }
      @if (!pendingLifecycle && !pendingActual && dashboard && dashboard.attendanceDates.length > 1) { <ng-container *ngTemplateOutlet="targetScopePicker"></ng-container> }
      @if (pendingLifecycle !== 'resume') {
        <app-attendance-reason-input [context]="dialogReasonContext" [label]="dialogReasonLabel" [(value)]="reason" [disabled]="releaseReadOnly || showSpinner" />
      }
      @if (errorMessage) { <p class="error-box" role="alert">{{ errorMessage }}</p> }
      <div class="dialog-actions">
        <button mat-raised-button [disabled]="showSpinner" (click)="cancelReason()">キャンセル</button>
        @if (pendingLifecycle) {
          <button mat-raised-button class="primary" [disabled]="releaseReadOnly || showSpinner || (pendingLifecycle !== 'resume' && !reason.trim())" (click)="saveLifecycle()">{{ lifecycleActionLabel }}</button>
        } @else if (pendingActual) {
          <button mat-raised-button class="primary" [disabled]="releaseReadOnly || showSpinner || !reason.trim()" (click)="saveActual()">変更する</button>
        } @else {
          <button mat-raised-button class="danger" [disabled]="releaseReadOnly || showSpinner || !reason.trim()" (click)="saveExclusion()">除外する</button>
        }
      </div>
    </section>
  </div>
}

<ng-template #additionPanel>
  @if (addCandidates.length) {
    <div class="add-panel">
      <div class="add-panel-title">追加する人と、この会議での役職を確認</div>
      @if (!setup && dashboard && dashboard.attendanceDates.length > 1) { <ng-container *ngTemplateOutlet="targetScopePicker"></ng-container> }
      @for (person of addCandidates; track person.id) {
        <div class="add-row"><div><strong>{{ person.name }}</strong><small>{{ person.affiliations.join('／') }}</small></div>
          <label>役職<select [(ngModel)]="person.roleId" [disabled]="releaseReadOnly || showSpinner"><option [ngValue]="null">選択してください</option>@for (role of additionRoles; track role.id) { <option [ngValue]="role.id">{{ role.name }}</option> }</select></label>
        </div>
      }
      <app-attendance-reason-input context="add" label="追加理由" [(value)]="addReason" [disabled]="releaseReadOnly || showSpinner" />
      <div class="panel-actions"><button mat-raised-button [disabled]="releaseReadOnly || showSpinner" (click)="cancelAdd()">キャンセル</button><button mat-raised-button class="primary" [disabled]="releaseReadOnly || showSpinner || !additionsValid" (click)="saveAdditions()">追加を確定</button></div>
    </div>
  }
</ng-template>

<ng-template #targetScopePicker>
  <label class="scope-picker">対象者変更の範囲<select [(ngModel)]="targetScope" [disabled]="releaseReadOnly || showSpinner"><option value="day">表示中の開催日のみ</option><option value="all">全開催日</option></select></label>
  @if (targetScope === 'all') { <p class="schedule-notice">過去の開催日も対象です。対象者数・参加率・報告書の実出席人数に反映されます。</p> }
</ng-template>
